import { render, staticRenderFns } from "./UploadPhotoModal.vue?vue&type=template&id=5b3fec5a&scoped=true"
import script from "./UploadPhotoModal.vue?vue&type=script&lang=js"
export * from "./UploadPhotoModal.vue?vue&type=script&lang=js"
import style0 from "./UploadPhotoModal.vue?vue&type=style&index=0&id=5b3fec5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3fec5a",
  null
  
)

export default component.exports